import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";

export default function SelectStudent({
  students,
  handleStudent,
  paySnack,
  selectedStudent,
}) {
  const { t } = useTranslation();


  const studentsWithLabel = students
    .filter((student) => !!student.student_name)
    .map((student) => ({
      ...student,
      label: student.student_name,
    }));

  console.log(students, "students here");

  return (
    <Autocomplete
      disabled={!students.length || paySnack}
      disablePortal
      value={Object.keys(selectedStudent).length ? selectedStudent : null}
      onChange={handleStudent}
      id="combo-box-demo"
      options={studentsWithLabel}
      sx={{ width: 200 }}
      renderInput={(params) => <TextField {...params} label={t("selectStudent")} />}
    />
  );
}
